import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Pain points" className="border-y border-grape/10 bg-white/70" data-id="element-97" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px',
      paddingTop: "27px"
    }} data-id="element-98" data-mp="26xmrx1867me0">
        <h2 className="text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-99" data-mp="2bvy3bge464yc">
          Does this sound like you?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-100" data-mp="21z36d1xhocm6">
          You know how to work a console. But after hours of calls, radio traffic and holdovers, the narrative
          still has to be written: factual, chronological and complete, with every time stamp matching CAD.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-grape" data-id="element-101" data-mp="3iemj1tis7v6g">
          It’s not a lack of skill. It’s a lack of a <span className="text-blush" data-id="element-102" data-mp="3nbwgnwgbrd5d">proven structure</span>.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-103" data-mp="1yzdp8skkanpp">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape/15 bg-cream p-5" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-104" data-mp="1u2dh8c45javy" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-105" data-mp="1b4kdx8pm8yy1">
                {p.emoji}
              </span>
              <div data-id="element-106" data-mp="1k1ut355k1888">
                <h3 className="text-sm font-bold text-plum" data-id="element-107" data-mp="1k5qyptzasvx3">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-108" data-mp="30g31zwxejj1e">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mx-auto mt-8 max-w-2xl rounded-2xl border border-blush/30 bg-blush-soft px-5 py-4 text-center" data-id="element-109" data-mp="1t55800xgijss">
          <p className="text-base font-bold text-plum" data-id="element-110" data-mp="1y3gkykj1taf8">
            Agencies are buying AI to review calls. <span className="text-blush-deep" data-id="element-111" data-mp="225bhlbq1azmo">Smart dispatchers use AI to finish their paperwork.</span>
          </p>
          <p className="mt-1 text-sm font-semibold text-plum/65" data-id="element-112" data-mp="273v8zrned3mf">Every call can be reviewed. Be ready.</p>
        </div>

        <div className="mt-12 text-center" data-id="element-113" data-mp="1ag8h8719q9fb">
          <p className="font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-114" data-mp="1efzdurdh7jrr">
            ✨ If you answered YES, SIGMA SMART™ has the solution.
          </p>
        </div>
      </div>
    </section>;
}